














































import { Component, Vue } from "vue-property-decorator";
import TermsAndConditionsLink from "@app/shared/components/termsAndConditions/termsAndConditionsLink.vue";
import * as ApplicationStore from "@src/store/applicationStore";

@Component({
    components: {
        TermsAndConditionsLink
    }
})
export default class ContactDetailsAndPrivacy extends Vue {
    private get contactDetails(): Array<ProxyModel.ContactDetailViewModel> {
        return [
          { name: "ASSESS Head Office", tel: "02 9261 5699", email: "admin@assessmedicalgroup.com.au" },
          { name: "advicor", tel: "+61 2 8467 6767", email: "admin@advicor.com.au" }
        ];
    }

    private getClassForContactDetails(index: number) : string {
      return index % 2 == 0 ? "col-5" : "col-4";
    }

    get isOfba(): boolean {
        return ApplicationStore.isOfba(this.$store);
    }
}
